import store from '../store'

export default [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../pages/Home.vue'),
    },
    {
        path: '/sobre',
        name: 'sobre',
        component: () => import(/* webpackChunkName: "sobre" */ '../pages/Sobre.vue'),
    },
    {
        path: '/trabalhos',
        name: 'trabalhos',
        component: () => import(/* webpackChunkName: "trabalhos" */ '../pages/Trabalhos.vue'),
        beforeEnter: (to, from, next) => {
            store.dispatch('taxo_trabalhos/turnOffAllTags')
            next()
        }
    },
    {
        path: '/trabalho/:slug',
        name: 'trabalho',
        component: () => import(/* webpackChunkName: "trabalho" */ '../pages/Trabalho.vue'),
    },
    {
        path: '/blog',
        name: 'posts',
        component: () => import(/* webpackChunkName: "posts" */ '../pages/Posts.vue'),
    },
    {
        path: '/blog/:slug',
        name: 'post',
        component: () => import(/* webpackChunkName: "post" */ '../pages/Post.vue'),
    },
    {
        path: '/contato',
        name: 'contato',
        component: () => import(/* webpackChunkName: "contato" */ '../pages/Contato.vue'),
    },
]
